import { action } from 'typesafe-actions';

import { ISystemInoperability } from 'ApiPackage/SystemInoperabilityModule/interfaces/ISystemInoperability';

import { SystemInoperabilityActionsEnum } from '../enums/SystemInoperabilityActionsEnum';

export const getSystemInoperabilityList = () =>
  action(SystemInoperabilityActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST);

export const setSystemInoperabilityList = (
  systemInoperabilityList: ISystemInoperability[],
  systemInoperabilityListPage: number,
  systemInoperabilityListPageCount: number,
  systemInoperabilityListTotalCount: number,
) => {
  return action(SystemInoperabilityActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST, {
    systemInoperabilityList,
    systemInoperabilityListPage,
    systemInoperabilityListPageCount,
    systemInoperabilityListTotalCount,
  });
};

export const setSystemInoperabilityListOrder = (order: string) =>
  action(SystemInoperabilityActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER, { order });

export const adminGetSystemInoperabilityListNextPage = () =>
  action(SystemInoperabilityActionsEnum.ADMIN_GET_SISTEM_INOPERABILITY_LIST_NEXT_PAGE);
